import { graphql } from 'services/api';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';
import { CREATE_PAGE, UPDATE_PAGE } from 'graphqlQueriesAndMutations/mutations';
import { generateUid } from 'utils/functions';

export async function saveShowCase(
	dataForm: DynamicShowCaseProps,
	handleNotify: any
) {
	const resp = { isSuccess: false, idItem: '' };
	try {
		const { data } = await graphql.mutate({
			mutation: CREATE_PAGE,
			variables: {
				createPageInput: {
					header_type: dataForm.header_type,
					name: dataForm.name,
					vtex_query: dataForm.vtex_query,
					show_tab_bar: dataForm.show_tab_bar
				}
			}
		});
		resp.isSuccess = true;
		resp.idItem = data?.createPage?.id || generateUid();
		handleNotify('Vitrine dinâmica salva com sucesso!', 'success');
	} catch (error: any) {
		resp.isSuccess = false;
		handleNotify(
			error?.message || 'Erro ao salvar a vitrine dinâmica',
			'error'
		);
	}

	return resp;
}

export async function updateShowCase(
	dataForm: DynamicShowCaseProps,
	handleNotify: any
) {
	const resp = { isSuccess: false, idItem: '' };
	try {
		const { data } = await graphql.mutate({
			mutation: UPDATE_PAGE,
			variables: {
				updatePageInput: {
					id: dataForm.id,
					header_type: dataForm.header_type,
					name: dataForm.name,
					vtex_query: dataForm.vtex_query,
					show_tab_bar: dataForm.show_tab_bar
				}
			}
		});
		resp.isSuccess = true;
		resp.idItem = data?.createPage?.id || generateUid();
		handleNotify('Vitrine dinâmica editada com sucesso!', 'success');
	} catch (error: any) {
		resp.isSuccess = false;
		handleNotify(
			error?.message || 'Erro ao editar a vitrine dinâmica',
			'error'
		);
	}

	return resp;
}
